import { Component, inject, OnInit } from '@angular/core';
import { GlobalService } from '@core/services/global.service';
import { UserData } from '@shared/types';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  private readonly GlobalService: GlobalService = inject(GlobalService);
  public userData: UserData | null = null;

  constructor() {}

  ngOnInit(): void {
    this.GlobalService.userData$.subscribe({
      next: (data) => {
        this.userData = data;
      },
    });
  }
}
